module.exports = __webpack_public_path__ + "img/xd.683917d2.svg";